import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Container,
  Heading,
  HStack,
  Icon,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Layout from "../../../components/student/Layout/layout";
import PdfPreviewModal, { homeworkSubmissionPdfUrl } from "../../../components/student/PdfPreviewModal";
import exams from "../../../assets/icons/exams.svg";

import {
  getHomeworkByIdRequest,
  getHomeworksByChapterIdRequest,
} from "../../../modules/students-modules/homework/Actions";
import { RiCalendarTodoFill } from "react-icons/ri";
import dayjs from "dayjs";
import SolveHomework from "../../../containers/student/models/solve-homework";
import { openSolveHomeworkModel } from "../../../modules/admin-modules/models/Actions";

const StudentHomeWork = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [selectedData, setSelectedData] = useState();
  const [pdfPreview, setPdfPreview] = useState(null);
  const chapterHomework = useSelector(
    (state) => state.studentHomework.chapterHomeworks
  );
  const isLoading = useSelector((state) => state.studentHomework.isLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    if (id) dispatch(getHomeworksByChapterIdRequest(id));
  }, [id]);
  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/homeworks/sections">
                <Text>Homeworks</Text>
              </Link>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <Text>{searchParams.get("name")}</Text>
            </BreadcrumbItem>
          </Breadcrumb>

          <Heading as="h3" color="main_1" textAlign="center" w="100%" mt={20}>
            {searchParams.get("name")}
          </Heading>
        </VStack>

        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          className="scroll"
          flexWrap="wrap"
          p="5px"
          mt="1.5"
        >
          {chapterHomework?.map((data, idx) => {
            return (
              <Box
                borderRadius="8px"
                w={{ base: "100%", md: "50%", lg: "30%" }}
                cursor="pointer"
                boxShadow={
                  selectedData?.id == data?.id
                    ? "2px 3px 10px #80808045"
                    : "none"
                }
                key={idx}
              >
                <HStack
                  bg="main_1_light"
                  borderRadius="8px"
                  p="20px"
                  color="main_1"
                  alignItems="flex-start"
                  spacing="15px"
                >
                  <Image
                    src={exams}
                    borderRadius="8px"
                    width="70px"
                    background="transparent"
                  />
                  <VStack alignItems="flex-start" spacing={2}>
                    <Text
                      fontSize="18px"
                      textTransform="capitalize"
                      fontWeight="500"
                    >
                      {data?.name}
                    </Text>

                    <HStack spacing="8px">
                      <Icon as={RiCalendarTodoFill} />
                      <Text>
                        {dayjs(data?.created_at).format("D , MMM ,YYYY")}
                      </Text>
                    </HStack>

                    {/* Status Display */}
                    {data?.student_homework && (
                      <VStack alignItems="flex-start" spacing={1}>
                        <Text fontSize="14px" fontWeight="500">
                          Status: {
                            data.student_homework.status === 0 ? "Pending" :
                            data.student_homework.status === 1 ? "Accepted" :
                            data.student_homework.status === 2 ? "Refused" : "Unknown"
                          }
                        </Text>
                        
                        {data.student_homework.evaluation && (
                          <Text fontSize="12px" color="gray.600">
                            Evaluation: {data.student_homework.evaluation}
                          </Text>
                        )}
                        
                        {data.student_homework.comment && (
                          <Text fontSize="12px" color="gray.600">
                            Comment: {data.student_homework.comment}
                          </Text>
                        )}
                      </VStack>
                    )}

                    <Button
                      onClick={() => {
                        const studentHomework = data?.student_homework;
                        const hasFile = studentHomework?.file;
                        const status = studentHomework?.status;
                        
                        // If status is 0 (pending) or 1 (accepted) and has file, preview it
                        if ((status === 0 || status === 1) && hasFile) {
                          const url = homeworkSubmissionPdfUrl(hasFile);
                          if (url) {
                            setPdfPreview({
                              url,
                              title: data?.name,
                              backLabel: "Back to homeworks",
                            });
                          }
                        } 
                        // If status is 2 (refused) or no submission yet, allow solve/resubmit
                        else if (status === 2 || !studentHomework) {
                          setSelectedData(data);
                          dispatch(openSolveHomeworkModel());
                        }
                      }}
                      disabled={data?.active === 0}
                      colorScheme={
                        data?.student_homework?.status === 2 ? "red" : 
                        data?.student_homework?.status === 1 ? "green" : 
                        "blue"
                      }
                    >
                      {(() => {
                        const studentHomework = data?.student_homework;
                        const hasFile = studentHomework?.file;
                        const status = studentHomework?.status;
                        
                        if ((status === 0 || status === 1) && hasFile) {
                          return "Preview";
                        } else if (status === 2) {
                          return "Resubmit";
                        } else {
                          return "Solve";
                        }
                      })()}
                    </Button>
                  </VStack>
                </HStack>
              </Box>
            );
          })}
          <SolveHomework
            data={selectedData}
            setSelectedData={setSelectedData}
          />
          <PdfPreviewModal
            isOpen={Boolean(pdfPreview?.url)}
            onClose={() => setPdfPreview(null)}
            pdfUrl={pdfPreview?.url || ""}
            title={pdfPreview?.title}
            backLabel={pdfPreview?.backLabel}
            totalPages={pdfPreview?.totalPages}
          />
        </Stack>
      </Container>
    </Layout>
  );
};

export default StudentHomeWork;
